import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=4694e8c3&scoped=true&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=4694e8c3&prod&scoped=true&lang=css&"
import style1 from "./AddCourse.vue?vue&type=style&index=1&id=4694e8c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694e8c3",
  null
  
)

export default component.exports